import { trackPromise } from 'react-promise-tracker';

export async function loginUser(credentials) {
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': 'Allow'
        },
        body: JSON.stringify(credentials)
    }).then(data => data.json()))
}